// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  --b: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  padding: 1px;
  background: conic-gradient(rgba(0, 0, 0, 0) 10%, #36f) content-box;
  -webkit-mask: repeating-conic-gradient(rgba(0, 0, 0, 0) 0deg, #000 1deg 20deg, rgba(0, 0, 0, 0) 21deg 36deg), radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - var(--b) - 1px), #000 calc(100% - var(--b)));
  -webkit-mask-composite: destination-in;
  mask-composite: intersect;
  animation: l4 1s infinite steps(10);
  z-index: 9999999 !important;
}

@keyframes l4 {
  to {
    transform: rotate(1turn);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/loader/loader.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kEAAA;EACA,sNAAA;EAEA,sCAAA;EACA,yBAAA;EACA,mCAAA;EACA,2BAAA;AAAF;;AAEA;EACE;IACE,wBAAA;EACF;AACF","sourcesContent":[".loader {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 50px;\r\n  --b: 8px;\r\n  aspect-ratio: 1;\r\n  border-radius: 50%;\r\n  padding: 1px;\r\n  background: conic-gradient(#0000 10%, #36f) content-box;\r\n  -webkit-mask: repeating-conic-gradient(#0000 0deg, #000 1deg 20deg, #0000 21deg 36deg),\r\n    radial-gradient(farthest-side, #0000 calc(100% - var(--b) - 1px), #000 calc(100% - var(--b)));\r\n  -webkit-mask-composite: destination-in;\r\n  mask-composite: intersect;\r\n  animation: l4 1s infinite steps(10);\r\n  z-index: 9999999 !important;\r\n}\r\n@keyframes l4 {\r\n  to {\r\n    transform: rotate(1turn);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
